<template>
  <div class="divider-wrap">
    <div class="divider">
      <p class="chinese">{{ chinese }}</p>
      <p class="english">{{ english }}</p>
      <p class="lineLeft"></p>
      <p class="lineRight"></p>
    </div>
    <p class="block"></p>
  </div>
</template>

<script>
export default {
  props: {
    chinese: {
      type: String,
      default: ''
    },
    english: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/css/sass/variable.scss';

.divider-wrap {
  padding: 60px 0 20px;
  position: relative;
}

.divider-main {
  background-color: #E6E6E6 !important;
  height: 1px !important;
}

.divider {
  color: $el-main-color;
  text-align: center;
  margin: 0 auto;
  position: relative;

  .chinese {
    font-size: 24px;
    color: #1B1E3F;
    margin-bottom: 10px;
  }

  .english {
    font-size: 16px;
    color: #646464;
  }

  .lineLeft {
    width: 400px;
    height: 1px;
    background: #E6E6E6;
    position: absolute;
    top: 52%;
    left: 0;
  }

  .lineRight {
    width: 400px;
    height: 1px;
    background: #E6E6E6;
    position: absolute;
    top: 52%;
    right: 0;
  }
}

.block {
  width: 8px;
  height: 8px;
  background: $el-main-color;
  position: absolute;
  bottom: -7px;
  left: 50%;
  margin: 0 -4px;
}
</style>
